import type { Phrases } from '../../common/Phrases.d';

import React, { useEffect, useRef, useState } from 'react';
import { ToggleButton } from '../../../../components/toggleButton/ToggleButton';
import { Row } from '../../../../components/Flex';
import { Fieldset } from '../../../../components/react-hook-form/Fieldset';
import { WhenDatePicker } from './WhenDatePicker';
import { WhenOtherTextField } from './WhenOtherTextField';
import { useFormContext } from '../../../../components/react-hook-form/FormContext';
import {
	SERVICES_FIELD_NAME,
	SERVICES_FREETEXT_FIELD_NAME,
	WHEN_LEGEND_ID,
} from '../constants';


export const WhenFieldset = ({
	phrases,
}: {
	phrases: Phrases;
}): React.JSX.Element => {
	const label = phrases['notificationForm.services.whenField.label'];
	const tooltipHtml = phrases['notificationForm.services.whenField.infoText.html'];
	const {
		setScrollRef,
		setValue,
	} = useFormContext();
	const scrollRef = useRef();

	const [showOther, setShowOther] = useState(false);

	useEffect(() => {
		if (scrollRef.current) {
			setScrollRef({
				el: scrollRef.current,
				field: SERVICES_FIELD_NAME.WHEN_DID_THE_INCIDENT_HAPPEN,
			});
			setScrollRef({
				el: scrollRef.current,
				field: SERVICES_FIELD_NAME.WHEN_DID_THE_INCIDENT_HAPPEN_OTHER,
			});
		}
	}, [scrollRef.current]);

	return (
		<Fieldset
			borderless
			legend={label}
			legendId={WHEN_LEGEND_ID}
			legendRef={scrollRef}
			legendTooltipHtml={tooltipHtml}
			name={SERVICES_FIELD_NAME.WHEN_DID_THE_INCIDENT_HAPPEN}
		>
			<Row className='gap-sm'>
				<WhenDatePicker phrases={phrases}/>
				<ToggleButton
					aria-labelledby={WHEN_LEGEND_ID}
					label={phrases['notificationForm.term.other']}
					pressed={showOther}
					onClick={() => {
						if (showOther) {
							// Yes, empty string can be set on optional text fields.
							setValue(SERVICES_FREETEXT_FIELD_NAME.WHEN_DID_THE_INCIDENT_HAPPEN_OTHER, '', { shouldValidate: true });
						}
						setShowOther(prev => !prev);
					}}
				/>
			</Row>
			<WhenOtherTextField phrases={phrases} showOther={showOther}/>
		</Fieldset>
	);
};
